import React, { useContext, useState } from 'react';
import '../../Css/chart.css';
import CartProduct from '../Integration/CartProduct';
import { StateContext } from '../../Middleware/context/StateProvider';
import Header from '../Integration/Header';
import BarraMenu from '../Integration/BarraMenu';
import Balance from '../Integration/Balance';

function Cart() {
  const { state } = useContext(StateContext);
  const [location, setLocation] = useState(null);

  const total = state.basket.reduce(
    (sum, item) => sum + item.price * item.quantity+item.taxa,
    0
  );



  return (
    <div>
      <Header />
      <BarraMenu />

      {/* BANNER DE BALANCE */}
      <Balance total={total} setLocation={setLocation} />

      <div className="div_chart">
        <div className="Chart_left">
          <h2>Seu Carrinho</h2>

          {state.basket.length === 0 && (
            <p>Seu carrinho está vazio.</p>
          )}

          {state.basket.map((item, index) => (
            <CartProduct key={index} {...item} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Cart;
